import {now} from '@acng/frontend-bounty/timing/now.js';
import {BOOLEAN, ENUM, INTEGER, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';

import {user} from '../../user/user.js';
import {media} from 'acng/core/service/env.js';
import {inject} from 'acng/core/service/ng.js';
import {getBonusModule} from '../service/template.js';

/**
 * @implements {BonusData}
 */
export class Bonus {
  /**
   * @param {BonusData} data
   */
  constructor(data) {
    ASSERT: {
      this.name = data.name;
      this.type = data.type;
      this.value = data.value;
      this.unique = data.unique;
      this.trigger_type = data.trigger_type;
      this.created_at = data.created_at;
      this.expires_at = data.expires_at;
      this.priority = data.priority;
    }

    Object.assign(this, data);
    this.expiresAt = data.expires_at ? new Date(data.expires_at) : null;
  }

  /**
   * @returns {?import('acng/layout/types').Timing}
   */
  get timing() {
    return this.expiresAt && this.expires() ? [null, now(), this.expiresAt.getTime()] : null;
  }

  /**
   * Method name is misleading.
   * @todo Rename into `showCountdown`
   * @returns {boolean}
   */
  expires() {
    return !!this.expiresAt && this.trigger_type !== 'bonus_action' && (this.expiresAt.getTime() - now() <= 24 * 36e5);
  }

  hasExpired() {
    return this.expires() && (this.expiresAt?.getTime() ?? Infinity) <= now();
  }

  click() {
    inject('payment').overlay(undefined, {bonus: this});
  }

  /**
   * @throws {Error} if the image is not available.
   *
   * @param {Valid<typeof BONUS_TEASER_FORMAT>} format
   */
  async getImageUrl(format) {
    //TODO: improve with next special
    // if (this.trigger_type == 'bonus_action') {
    //   return `${ASSET_PATH}${this.name}/payment/${format}_${locale.get()}.jpg`;
    // }
    const {default: getBonusBannerSrc} = await getBonusModule();
    DEBUG: console.debug({name: this.name, format});
    DEBUG: console.debug(`${media.assets_ext}/${getBonusBannerSrc(this.name, format, user.fsk)}`);
    return `${media.assets_ext}/${getBonusBannerSrc(this.name, format, user.fsk)}`;
  }
}

const IMAGE_FORMAT_OVERLAY = 'overlay';
const IMAGE_FORMAT_SIDEBAR = 'sidebar';
const IMAGE_FORMAT_FRONTPAGE_BOTTOM = 'frontpage-bottom';

const IMAGE_FORMATS = /** @type {const} */ ([IMAGE_FORMAT_OVERLAY, IMAGE_FORMAT_SIDEBAR, IMAGE_FORMAT_FRONTPAGE_BOTTOM]);

/**
 * Validate a bonus teaser image format.
 */
export const BONUS_TEASER_FORMAT = /** @__PURE__ */ ENUM(IMAGE_FORMATS);

/**
 * @typedef {Valid<typeof BONUS_DATA>} BonusData
 */

export const BONUS_DATA = /* @__PURE__ */ OBJECT({
  name: STRING,
  type: ENUM(/** @type {const} */ (['percent', 'fixed', 'package'])),
  value: INTEGER,
  unique: BOOLEAN,
  trigger_type: ENUM(/** @type {const} */ (['bonus_action', null])),
  created_at: STRING,
  expires_at: NULLABLE(STRING),
  priority: INTEGER,
});
